var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-box"},[_c('span',[_vm._v("\n      Copyright © 2018择贤网 京140269520号-2  京公网安备 11010803055043号\n    ")])])}]

export { render, staticRenderFns }